import { render, staticRenderFns } from "./SnapshotConfiguration.vue?vue&type=template&id=4be917b0"
import script from "./SnapshotConfiguration.vue?vue&type=script&lang=js"
export * from "./SnapshotConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports